import './aquarium-teaser.scss';

require('../../assets/images/light_wood.jpeg');
require('../../assets/images/dark_wood.jpeg');

/**
 * Controller für den Aquarium-Teaser Bereich.
 *
 * Verantwortlich für das Auswählen relevanter DOM-Elemente im Teaser und
 * das Lazy-Initialisieren der In-View-Observation für Elemente mit dem
 * [data-inview]-Attribut, die noch nicht im Viewport sind.
 *
 * Öffentliche API: new AquariumTeaser($root).initialize()
 */
class AquariumTeaser {
    /**
     * @param {HTMLElement} $element Wurzel-Element des Aquarium-Teasers.
     */
    constructor ($element) {
        /** @type {HTMLElement} */
        this.$root = $element;
        /** @type {HTMLElement|null} */
        this.$list = this.$root.querySelector('[data-aquarium-teaser="list"]');
        /** @type {NodeListOf<HTMLElement>} */
        this.$$items = this.$root.querySelectorAll('[data-aquarium-teaser="item"]');
        /** @type {NodeListOf<HTMLElement>} */
        this.$$inViewCandidates = document.querySelectorAll('[data-inview]:not(.inview)');

        // Kleines Delay, bis Observer garantiert verfügbar ist (historisches Verhalten beibehalten)
        setTimeout(() => {
            this.$$inViewCandidates.forEach((el) => {
                // Defensive: Observer nur nutzen, wenn vorhanden
                window?.inViewObserver?.observe?.(el);
            });
        }, 500);
    }

    /**
     * Initialisiert den Teaser. Aktuell rein diagnostisch (keine Seiteneffekte
     * außer einem optionalen Log). Kann gefahrlos mehrfach aufgerufen werden.
     *
     * @returns {void}
     */
    initialize () {
        // Hinweis: bestehendes Verhalten (Logging) wird beibehalten
        // eslint-disable-next-line no-console
        console.log(this.$list, this.$$items);
    }
}

export { AquariumTeaser };

// Initialisiert alle Aquarium-Teaser, sobald der benutzerdefinierte content.loaded-Event feuert
window.addEventListener('content.loaded', (e) => {
    const { $context } = e.detail ?? {};
    if (!$context) return;

    const $$roots = $context.querySelectorAll('[data-aquarium-teaser="root"]');
    if (!$$roots.length) return;

    $$roots.forEach(($root) => {
        const teaser = new AquariumTeaser($root);
        teaser.initialize();
    });
});
